module.exports = __webpack_public_path__ + "static/media/arrow-left.227b3ab3.svg";